export const nationalities = [
  "Afghan",
  "Albanian",
  "Algerian",
  "American",
  "Andorran",
  "Angolan",
  "Argentine",
  "Armenian",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bahraini",
  "Bangladeshi",
  "Belarusian",
  "Belgian",
  "Belizean",
  "Beninese",
  "Bhutanese",
  "Bolivian",
  "Bosnian",
  "Brazilian",
  "British",
  "Bruneian",
  "Bulgarian",
  "Burkinabe",
  "Burmese",
  "Burundian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Cape Verdean",
  "Chadian",
  "Chilean",
  "Chinese",
  "Colombian",
  "Comorian",
  "Congolese",
  "Costa Rican",
  "Croatian",
  "Cuban",
  "Cypriot",
  "Czech",
  "Danish",
  "Djiboutian",
  "Dominican",
  "Dutch",
  "East Timorese",
  "Ecuadorean",
  "Egyptian",
  "Emirati",
  "English",
  "Equatorial Guinean",
  "Eritrean",
  "Estonian",
  "Ethiopian",
  "Fijian",
  "Finnish",
  "French",
  "Gabonese",
  "Gambian",
  "Georgian",
  "German",
  "Ghanaian",
  "Greek",
  "Grenadian",
  "Guatemalan",
  "Guinean",
  "Guyanese",
  "Haitian",
  "Honduran",
  "Hungarian",
  "Icelandic",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Ivorian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazakh",
  "Kenyan",
  "Kuwaiti",
  "Kyrgyz",
  "Laotian",
  "Latvian",
  "Lebanese",
  "Liberian",
  "Libyan",
  "Lithuanian",
  "Luxembourgish",
  "Macedonian",
  "Malagasy",
  "Malaysian",
  "Maldivian",
  "Malian",
  "Maltese",
  "Mauritanian",
  "Mauritian",
  "Mexican",
  "Moldovan",
  "Monacan",
  "Mongolian",
  "Montenegrin",
  "Moroccan",
  "Mozambican",
  "Namibian",
  "Nepalese",
  "New Zealander",
  "Nicaraguan",
  "Nigerian",
  "Nigerien",
  "North Korean",
  "Norwegian",
  "Omani",
  "Pakistani",
  "Palestinian",
  "Panamanian",
  "Papua New Guinean",
  "Paraguayan",
  "Peruvian",
  "Philippine",
  "Polish",
  "Portuguese",
  "Qatari",
  "Romanian",
  "Russian",
  "Rwandan",
  "Salvadoran",
  "Samoan",
  "Saudi",
  "Scottish",
  "Senegalese",
  "Serbian",
  "Seychellois",
  "Sierra Leonean",
  "Singaporean",
  "Slovak",
  "Slovenian",
  "Somali",
  "South African",
  "South Korean",
  "Spanish",
  "Sri Lankan",
  "Sudanese",
  "Surinamese",
  "Swazi",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Tajik",
  "Tanzanian",
  "Thai",
  "Togolese",
  "Tongan",
  "Tunisian",
  "Turkish",
  "Turkmen",
  "Ugandan",
  "Ukrainian",
  "Uruguayan",
  "Uzbek",
  "Venezuelan",
  "Vietnamese",
  "Welsh",
  "Yemeni",
  "Zambian",
  "Zimbabwean",
];
export const accommodations = [
  // Arabic African
  { label: "Egypt", value: "egypt" },
  { label: "Morocco", value: "morocco" },
  { label: "Algeria", value: "algeria" },
  { label: "Tunisia", value: "tunisia" },
  { label: "Sudan", value: "sudan" },
  { label: "Libya", value: "libya" },
  { label: "Mauritania", value: "mauritania" },
  // Arabic Asian
  { label: "UAE", value: "uae" },
  { label: "United Arab Emirates", value: "united arab emirates" },
  { label: "Saudi Arabia", value: "saudi arabia" },
  { label: "Qatar", value: "qatar" },
  { label: "Bahrain", value: "bahrain" },
  { label: "Oman", value: "oman" },
  { label: "Jordan", value: "jordan" },
  { label: "Lebanon", value: "lebanon" },
  { label: "Iraq", value: "iraq" },
  { label: "Syria", value: "syria" },
  { label: "Palestine", value: "palestine" },
  { label: "Yemen", value: "yemen" },
  { label: "Kuwait", value: "kuwait" },
  // Europe
  { label: "Germany", value: "germany" },
  { label: "France", value: "france" },
  { label: "Italy", value: "italy" },
  { label: "Spain", value: "spain" },
  { label: "Netherlands", value: "netherlands" },
  { label: "Switzerland", value: "switzerland" },
  { label: "Belgium", value: "belgium" },
  { label: "Austria", value: "austria" },
  { label: "Sweden", value: "sweden" },
  { label: "Norway", value: "norway" },
  { label: "Denmark", value: "denmark" },
  { label: "Finland", value: "finland" },
  { label: "Ireland", value: "ireland" },
  { label: "Portugal", value: "portugal" },
  { label: "Greece", value: "greece" },
  { label: "Poland", value: "poland" },
  { label: "Hungary", value: "hungary" },
  { label: "Czech", value: "czech" },
  { label: "Slovakia", value: "slovakia" },
  { label: "Romania", value: "romania" },
  { label: "Bulgaria", value: "bulgaria" },
  { label: "Croatia", value: "croatia" },
  { label: "Slovenia", value: "slovenia" },
];

export const educationLevels = [
  "High School Student",
  "Bachelor Student",
  "Master Student",
  "Bachelor Graduate",
  "Master Graduate",
  "PhD Candidate",
  "PhD Graduate",
  "Other",
];
